import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=a29a5732&scoped=true"
import script from "./Bookings.vue?vue&type=script&lang=js"
export * from "./Bookings.vue?vue&type=script&lang=js"
import style0 from "./Bookings.vue?vue&type=style&index=0&id=a29a5732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29a5732",
  null
  
)

export default component.exports